import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../login/auth.service';
import { Filter } from '../../../helpers/tableview';

@Injectable()
export class UsersService {

    private headers: Headers;
    private url = environment.apiUrl;

    constructor(private http: Http, private authService: AuthService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    public getUsers(filter: Filter): Promise<any> {
        return this.http
          .post(this.url+'/admin/users', filter, {headers: this.headers})
          .toPromise()
          .then(res => { return {items: res.json().users, total: res.json().total}})
          .catch(this.handleError);
    }

    public toggleAdminRights(userID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/usersRights/'+userID+'/admin', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    public toggleManagerRights(userID: number): Promise<any> {
        return this.http
        .post(this.url+'/admin/usersRights/'+userID+'/manager', {}, {headers: this.headers})
        .toPromise()
        .then(res => res.json().result)
        .catch(this.handleError);
    }

    public toggleMaintainerRights(userID: number): Promise<any> {
      return this.http
      .post(this.url+'/admin/usersRights/'+userID+'/maintainer', {}, {headers: this.headers})
      .toPromise()
      .then(res => res.json().result)
      .catch(this.handleError);
  }

    public toggleBanStatus(userID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/users/'+userID+'/ban', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().user_status)
          .catch(this.handleError);
    }

    public approveInvoice(userID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/users/'+userID+'/approve', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    public rejectInvoice(userID: number): Promise<any> {
        return this.http
          .post(this.url+'/admin/users/'+userID+'/reject', {}, {headers: this.headers})
          .toPromise()
          .then(res => res.json().result)
          .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
      console.error('An error occurred', error);
      return Promise.reject(error.message || error);
    }
}


export enum InvoiceStatus {
  none = 1,
  pending,
  rejected,
  approved
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/users/users.service.ts